export default __webpack_public_path__ + "locales/es/DataReassignmentDialog.json?hash=3c0ed1e89ea0b91fc7b3bdd7bfadc22b";